export * from './error.component';
export * from './unauthorized.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/error/index.ts